import { useMutation } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type SendMicrosoftEmailPayload = {
  recipient: string;
  subject: string;
  body: string;
};

export const useSendMicrosoftEmailMutation = () => {
  const {
    mutateAsync,
    isPending: isLoading,
    isError,
  } = useMutation<{ data: unknown }, Error, SendMicrosoftEmailPayload>({
    mutationFn: (payload: SendMicrosoftEmailPayload) =>
      api.post<unknown>('microsoft-email/send', payload),
  });

  const sendEmail = async (payload: SendMicrosoftEmailPayload): Promise<void> => {
    await mutateAsync(payload);
  };

  return {
    sendEmail,
    isLoading,
    isError,
  };
};
